import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Panduan from "@/pages/Panduan";
import Profil from "@/pages/Profil";
import Assessment from "@/pages/Assessment";
import Ideas from "@/pages/Ideas";
import Validation from "@/pages/Validation";
import Comparison from "@/pages/Comparison";
import Blueprint from "@/pages/Blueprint";
import Launch from "@/pages/Launch";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App font-body">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/panduan" element={<ProtectedRoute><Panduan /></ProtectedRoute>} />
            <Route path="/profil" element={<ProtectedRoute><Profil /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute requireAdmin><Admin /></ProtectedRoute>} />
            <Route path="/assessment" element={<ProtectedRoute requireActive><Assessment /></ProtectedRoute>} />
            <Route path="/ideas" element={<ProtectedRoute requireActive><Ideas /></ProtectedRoute>} />
            <Route path="/validation" element={<ProtectedRoute requireActive><Validation /></ProtectedRoute>} />
            <Route path="/comparison" element={<ProtectedRoute requireActive><Comparison /></ProtectedRoute>} />
            <Route path="/blueprint" element={<ProtectedRoute requireActive><Blueprint /></ProtectedRoute>} />
            <Route path="/launch" element={<ProtectedRoute requireActive><Launch /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
